import { Button } from "../ui/components/Button";


export class UploadButton extends Button {
    init() {
        this.includeComponents({
            uploadModal: "document@#upload-modal",
        });

        this.on('click', () => {
            this.uploadModal.show();
        });
    }

}
